export const numberToHexColor = (n: number) => `#${(n || 0).toString(16).padStart(6, '0')}`;
